import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { updateServiceConfig } from 'owa-service/lib/config';
import {
    lazyExecuteMsalNestedAppAuthRequest,
    lazyPrefetchMsalNestedAppAuthRequest,
} from 'owa-msaljs/lib/lazyFunctions';

export default async function initializeNestedAppAuthExecutor(): Promise<void> {
    if (isGlobalFeatureEnabled('auth-naa-web')) {
        // Nested App Auth allows hosted MetaOS/add-ins to get tokens from the host using MSAL; enable
        // this by setting the callback that will be used for fulfilling NAA requests
        updateServiceConfig({
            executeNaaRequest: lazyExecuteMsalNestedAppAuthRequest.importAndExecute,
            prefetchNaaRequest: lazyPrefetchMsalNestedAppAuthRequest.importAndExecute,
        });
    }
}

export type InitializeNestedAppAuthExecutorFunc = typeof initializeNestedAppAuthExecutor;
